import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Login } from "../screens/Login/Login";

export const LoginRouter = () => {
  return (
    <Routes>
      <Route path={"/"} element={<Login />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
